module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/main/main.component.scss
// module id = ./src/app/main/main.component.scss
// module chunks = main